import React, { useEffect, useState } from "react";
import {
  avatar,
  card_marvin,
  dummyCard,
  feed_req,
  feeds1,
  feeds2,
  feeds3,
  placeholder,
  placeholder_feed,
  subscription,
} from "../../../../assets";
import { useNavigate } from "react-router";
import { HiDotsVertical } from "react-icons/hi";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiFillLike, AiOutlineLike } from "react-icons/ai";
import { FaPlus, FaRegCommentDots } from "react-icons/fa";
import { RiShareForwardLine } from "react-icons/ri";
import { toastMessage } from "../../../../utils/toastMessage";
import {
  feedDetailApi,
  feedListApi,
  feedReactionApi,
} from "../../../../services/feeds";
import "../groupDetailSubModules/Feeds.css";
import { reactions } from "../../../../utils/staticData";
import { GoPlus } from "react-icons/go";
import CustomModal from "../../../../Components/modals/CustomModal";
import { CiCircleCheck } from "react-icons/ci";
import OverviewComment from "../../Overview/section/OverviewComment";
import OverviewReport from "../../Overview/section/OverviewReport";
import moment from "moment";
import { handleCopy } from "../../../../utils/copyClipboard";
import FeedRequest from "./FeedRequest";
import InfiniteScroll from "react-infinite-scroll-component";
import OverviewListShimmer from "../../../../shimmer/overview/OverviewListshimmer";
import Slider from "react-slick";
import DeleteFeed from "../../Overview/section/DeleteFeed";
import { feedDetailsLink } from "../../../../utils/shareLink";

const Feeds = ({ groupId, groupDetail, showAuth }) => {
  const [feedList, setFeedList] = useState([]);
  const [commentModal, setCommentModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [feedRequestModal, setFeedRequestModal] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [deleteModal, setDeleteModal] = useState(false);
  // console.log('selectedData', selectedData);
  // ---------handle-commit------------
  const handleComment = (data) => {
    setSelectedData(data);
    setCommentModal(true);
  };
  // ---------handle-commit------------
  const handleReport = (data) => {
    setSelectedData(data);
    setReportModal(true);
  };
  //----------handle-feed-request------------
  const handleFeedRequest = (data) => {
    setFeedRequestModal(true);
  };
  // ---------handle-Delete------------
  const handleDelete = (data) => {
    setSelectedData(data);
    setDeleteModal(true);
  };
  // ----------------list-feed-API--------------------
  const getFeedListHandler = async (page = 1, isRefresh = false) => {
    try {
      const query = {
        _group: groupId,
        pagination: true,
        page,
        limit: 9,
      };
      const { data } = await feedListApi(query);

      const { success, message, data: response } = data;
      if (success) {
        if (isRefresh) {
          setFeedList(response || []);
        } else {
          setFeedList((prev) => [...prev, ...(response || [])]);
        }
        setHasMore(response.length === 9);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getFeedListHandler(1, true);
  }, [groupId]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      getFeedListHandler(nextPage);
      return nextPage;
    });
  };
  // -----------handle-reaction-API---------------------
  const handleFeedsReaction = async (reaction, feedData) => {
    try {
      setSelectedData(feedData || {});
      const { data } = await feedReactionApi({
        _feed: feedData?._id,
        reaction,
      });
      const { success, message } = data;
      if (success) {
        getFeedDetail(feedData?._id);
      } else {
        toastMessage(
          message,
          success ? "success" : "error",
          "handleFeedsReaction"
        );
      }
    } catch (e) {
      console.error(e.message);
    }
  };
  //----------feed-details-api---------------
  const getFeedDetail = async (_id) => {
    try {
      const { data } = await feedDetailApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        // Find the item in categoryList
        const findIndex = feedList?.findIndex((data) => data?._id === _id);
        if (findIndex !== -1) {
          setFeedList((prev) =>
            prev.map((item, index) => (index == findIndex ? response : item))
          );
        }
      } else {
        toastMessage(message, "error", "getFeedDetail");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <>
      <div className="live_group_parent new_feed_req">
        {groupDetail?.admin?._user === showAuth?._id &&
          groupDetail?.settings?.approveFirstPost && (
            <div
              className="live_group_left"
              onClick={() => handleFeedRequest(groupDetail)}
            >
              <img src={feed_req} />
              <div className="live_grp_txt">
                <b>New Feed Requests</b>
                <p>All requested feeds are here</p>
              </div>
            </div>
          )}
      </div>
      <InfiniteScroll
        dataLength={feedList.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<OverviewListShimmer count={9} />}
        endMessage={
          <p style={{ textAlign: "center", margin: "25px" }}>
            <b>No more data to display</b>
          </p>
        }
      >

        <div className="cards_container">
          {feedList && feedList?.length > 0 ? (
            feedList?.map((data, index) => (
              <React.Fragment key={index}>
                <div className="_card">
                  <div className="_cards_header">
                    <div className="cardtop_header">
                      <img src={data?._group?.coverImage} alt="User Image" />
                      <div className="info">
                        <div className="name">
                          {data?._group?.name || "N/A"}
                        </div>
                        <div className="time">
                          {data?.createdBy?.fullName && (
                            <>
                              Posted by{" "}
                              {data?._group?.settings?.anonymousPosting
                                ? "Anonymous"
                                : data?.createdBy?.fullName}{" "}
                              - {moment(data?.createdAt).fromNow()}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <HiDotsVertical />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {data?.createdBy?._id === showAuth?._id ? (
                          <>
                            <Dropdown.Item
                              as={Link}
                              to={`/dashboard/feed/edit-feed/${data?._id}`}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDelete(data)}>
                              Delete
                            </Dropdown.Item>
                          </>
                        ) : (
                          <Dropdown.Item onClick={() => handleReport(data)}>
                            Report
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="card_image">
                    <Link
                      to={`/dashboard/group/feed/detail/${data?._group?._id}/${data?._id}`}
                    >
                      <div className="upload_cover">
                        <div className="slider_banner">
                          <Slider {...settings}>
                            {data?.attachments &&
                            data?.attachments?.length > 0 ? (
                              data?.attachments?.map((data, ind) => (

                                <div
                                  key={ind}
                                  className="upload_design_content overwrite_upload_design_content"
                                >
                                  {data.type === "VIDEO" ? (
                                    <video
                                      controls
                                      width="100%"
                                      poster={data.thumbnailUrl}
                                    >
                                      <source src={data.url} type="video/mp4" />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  ) : (
                                    <img src={data.url} alt="attachment" />
                                  )}
                                </div>
                                
                              ))
                            ) : (

                              <div className="upload_design_content overwrite_upload_design_content">
                                <img src={dummyCard} alt="attachment" />
                              </div>

                            )}
                          </Slider>
                        </div>
                      </div>
                      <span className="tag">{data?._group?.categoryName}</span>
                    </Link>
                  </div>

                  <Link
                    to={`/dashboard/group/feed/detail/${data?._group?._id}/${data?._id}`}
                  >
                    <div className="card_content">
                      <h3>{data?.title} </h3>
                    </div>
                  </Link>

                  <div className="card_footer">
                    <button className="card_footer_btn">
                      {reactions?.map((reactionData, ind) => (
                        <span
                          key={ind}
                          className="me-2"
                          onClick={() =>
                            handleFeedsReaction(reactionData?.name, data)
                          }
                        >
                          {data?.myReaction?.[reactionData?.name]
                            ? reactionData?.fillEmoji
                            : reactionData?.emoji}
                          {data?.reactions?.[reactionData?.name] || ""}
                        </span>
                      ))}
                    </button>

                    <button
                      className="card_footer_btn"
                      onClick={() => handleComment(data)}
                    >
                      <FaRegCommentDots /> Comments
                    </button>
                    <button
                      onClick={() => handleCopy(`${feedDetailsLink}${data?._group?._id}/${data?._id}`)}
                      className="card_footer_btn"
                    >
                      <RiShareForwardLine /> Share
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ))
          ) : (
            <div className="feed_placeholder">
              <img src={placeholder_feed} />
            </div>
          )}
        </div>


      </InfiniteScroll>

      {/* ---------comments--------------------- */}
      {commentModal && (
        <OverviewComment
          show={commentModal}
          close={() => setCommentModal(false)}
          selectedData={selectedData}
        />
      )}
      {/* ---------report--------------------- */}
      {reportModal && (
        <OverviewReport
          show={reportModal}
          close={() => setReportModal(false)}
          selectedData={selectedData}
          pageName="Post"
          type="FEED"
          id={selectedData?._group?._id}
        />
      )}
      {/* //-----------feed-request----------------- */}
      {feedRequestModal && (
        <FeedRequest
          show={feedRequestModal}
          close={() => setFeedRequestModal(false)}
          listing={getFeedListHandler}
          groupId={groupId}
          setPage={setPage}
          setHasMore={setHasMore}
        />
      )}
      {/* //-----------feed-request----------------- */}
      {deleteModal && (
        <DeleteFeed
          show={deleteModal}
          close={() => setDeleteModal(false)}
          scroll={true}
          listing={getFeedListHandler}
          id={selectedData?._id}
          feedName={selectedData?._group?.name}
          setPage={setPage}
          setHasMore={setHasMore}
        />
      )}
    </>
  );
};

export default Feeds;
